import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { ExamDetails } from "@memorang/types/src/exams";
import { commerceBasePath } from "./constants";
import type { ExamDetailsResponse } from "./types";

export const fetchExamsList = async (): Promise<ExamDetails[]> => {
	const { data } = await authAxios.get(
		`${API_BASE_URL}/${commerceBasePath}/exam-list`,
	);
	return data.data;
};

export const fetchExamDetails = async ({
	examId,
	sku,
}: {
	examId: string;
	sku?: string;
}): Promise<ExamDetailsResponse> => {
	const { data } = await authAxios.get(
		`${API_BASE_URL}/${commerceBasePath}/exam-details`,
		{
			params: {
				examId,
				sku,
			},
		},
	);
	return data.data;
};

type Params = {
	examId: string;
	metadata: {
		examDate: string;
	};
};
export const updateExamDetails = async (params: Params) => {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/${commerceBasePath}/exam-meta-details`,
		{
			...params,
		},
	);
	return data.data;
};
